import { Routes, Route, Navigate } from 'react-router-dom'
import { useBootstrapAuth } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ResetareParolaPage } from './pages/ResetareParolaPage'
import { AppShell } from './components/AppShell'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ClientiPage } from './pages/ClientiPage'
import { ClientDetailPage } from './pages/ClientDetailPage'
import { ComenziPage } from './pages/emag/ComenziPage'
import { FacturiVanzarePage } from './pages/emag/FacturiVanzarePage'
import { FacturiCumpararePage } from './pages/emag/FacturiCumpararePage'
import { GeneratorEaPage } from './pages/emag/GeneratorEaPage'
import { VerificarePage } from './pages/emag/VerificarePage'
import { RetururiPage } from './pages/emag/RetururiPage'
import { SetariPage } from './pages/SetariPage'
import { PlaceholderPage } from './pages/PlaceholderPage'

export function App() {
  useBootstrapAuth()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/resetare-parola" element={<ResetareParolaPage />} />

      <Route element={<ProtectedRoute />}>
        <Route
          path="/"
          element={
            <AppShell>
              <DashboardPage />
            </AppShell>
          }
        />
        <Route
          path="/clienti"
          element={
            <AppShell>
              <ClientiPage />
            </AppShell>
          }
        />
        <Route
          path="/clienti/:id"
          element={
            <AppShell>
              <ClientDetailPage />
            </AppShell>
          }
        />
        <Route path="/comenzi" element={<AppShell><ComenziPage /></AppShell>} />
        <Route path="/facturi-vanzare" element={<AppShell><FacturiVanzarePage /></AppShell>} />
        <Route path="/facturi-cumparare" element={<AppShell><FacturiCumpararePage /></AppShell>} />
        <Route path="/incasari" element={<AppShell><GeneratorEaPage /></AppShell>} />
        <Route path="/retururi" element={<AppShell><RetururiPage /></AppShell>} />
        <Route path="/verificare" element={<AppShell><VerificarePage /></AppShell>} />
        <Route path="/setari" element={<AppShell><SetariPage /></AppShell>} />
        {[
          ['/vouchere', 'Vouchere'],
        ].map(([path, title]) => (
          <Route
            key={path}
            path={path}
            element={
              <AppShell>
                <PlaceholderPage title={title} />
              </AppShell>
            }
          />
        ))}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
